import React from 'react';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import CardBody from '../../../shared/components/CardBody';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import Paginator from '../../../shared/components/Paginator';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import { PsMessageStates } from '../PsMessageStates';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { MessageSearchTask } from '../shared/message-search/MessageSearchTask';
import { MessageSearchRequest } from '../shared/message-search/MessageSearchRequest';
import { PsMessage } from '../PsMessage';
import { MessageListTable } from './MessageListTable';

export class MessageListCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            error: '',
            search: '',
            loading: false,
            page: 1,
            pagination: {
                current: 0,
                total_pages: 0,
                total_elements: 0,
            },
            filter: PsMessageStates.ALL,
            filters: [
                {
                    id: PsMessageStates.ALL,
                    title: I18nUtils.tr('TR_TODAS'),
                    active: true,
                    onClick: this.selectFilter(PsMessageStates.ALL),
                },
                {
                    id: PsMessageStates.OPENED,
                    title: I18nUtils.tr('TR_ABIERTAS'),
                    active: false,
                    onClick: this.selectFilter(PsMessageStates.OPENED),
                },
                {
                    id: PsMessageStates.CLOSED,
                    title: I18nUtils.tr('TR_CERRADAS'),
                    active: false,
                    onClick: this.selectFilter(PsMessageStates.CLOSED),
                },
            ],
        };
    }

    componentDidMount() {
        this.listMessages();
    }

    render() {
        const {
            data,
            error,
            search,
            filters,
            loading,
            pagination,
        } = this.state;

        return (
            <Row clearfix>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODOS_LOS_MENSAJES')}
                        subtitle={this.subtitle()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                onSearch={this.searchTerm}
                                onRefresh={this.listMessages}
                                searchText={search}
                                enableFilter={true}
                                filterOptions={filters}
                            />
                        )}
                    />
                    <CardBody>
                        <MessageListTable
                            data={data}
                            error={error}
                            loading={loading}
                        />
                        <Paginator
                            data={pagination}
                            onPage={this.selectPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

    subtitle = () => {
        switch ( this.state.filter ) {
            case PsMessageStates.ALL:
                return I18nUtils.tr('TR_TODAS');
            case PsMessageStates.OPENED:
                return I18nUtils.tr('TR_ABIERTAS');
            case PsMessageStates.CLOSED:
                return I18nUtils.tr('TR_CERRADAS');
            default:
                return '';
        }
    };

    selectPage = (page) => {
        this.setState({ page }, this.listMessages);
    };

    searchTerm = (search) => {
        this.setState({ search, page: 1 }, this.listMessages);
    };

    selectFilter = (filter) => () => {
        this.setState(
            (prevState) => ( {
                page: 1,
                filter,
                filters: prevState.filters.map((f) => ( {
                    ...f,
                    active: f.id === filter,
                } )),
            } ),
            this.listMessages,
        );
    };

    listMessages = () => {
        const { page, search, filter } = this.state;
        const request = new MessageSearchRequest();

        request.setPage(page);
        request.setTerm(search);
        request.setState(filter);

        new MessageSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const data = PsMessage.fromAPIMessages(res.data);
                this.setState({ data, pagination: res.pagination });
            })
            .onFail((error) => this.setState({ error }))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };
}

MessageListCard.propTypes = {};

MessageListCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/list/MessageListCard.jsx